module.exports = __webpack_public_path__ + "static/vib_play9s-3b58f21d24acd59fe051db45db8c139a.jpg";